import axios from "axios";
import React from "react";
import styles from "./Message.module.css";
const Message = ({message }) => {
  return (
    <div className={styles.messageOwn}>
      <span className={styles.chatText}>{message.body}</span>
      <span className={styles.chatTime}>{message.created_at}</span>
    </div>
  );
};

export default Message;
